import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
const neighborhoodsData = [{
  name: 'Minneapolis',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600'
}, {
  name: 'Edina',
  image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600'
}, {
  name: 'Minnetonka',
  image: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=600'
}, {
  name: 'Saint Paul',
  image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600'
}];
export const Neighborhoods = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].neighborhoods;
  return <FadeInSection id="neighborhoods" className="w-full bg-[#f8f4ef] py-24 lg:py-32" data-id="element-204" data-mp="15wdbiop5ji5d">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12" data-id="element-205" data-mp="8csdbb405z9n">
        <div className="flex flex-col items-center text-center mb-16" data-id="element-206" data-mp="dcy1ghb2d3mz">
          <span className="eyebrow mb-4" data-id="element-207" data-mp="3m1w5l6sc0iuk">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a]" data-id="element-208" data-mp="3m3h0ixik63sy">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-209" data-mp="3cai08idp8oti">
          {neighborhoodsData.map((hood, index) => <div key={index} className="group relative h-[460px] w-full overflow-hidden cursor-pointer" data-id="element-210" data-mp="389psxuoe0tzv" data-mpi={index}>
              <img src={hood.image} alt={hood.name} className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-110" data-id="element-211" data-mp="2yb8vceuy1h4u" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500 group-hover:from-black/90" data-id="element-212" data-mp="2pcwwjpjxbd1b" />

              <div className="absolute bottom-8 left-8 right-8" data-id="element-213" data-mp="njh20hkpte12">
                <h3 className="font-serif-display text-2xl text-white uppercase tracking-wider" data-id="element-214" data-mp="2h2g3hh2mzqlg">
                  {hood.name}
                </h3>
                <div className="w-0 h-px bg-[#c9a96e] mt-4 transition-all duration-500 group-hover:w-12" data-id="element-215" data-mp="2lty2w0p0hj4b" />
              </div>
            </div>)}
        </div>
      </div>
    </FadeInSection>;
};